module.exports = __webpack_public_path__ + "static/media/icon-confirmed.4edc3315.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-confirmed.svg
// module id = 934
// module chunks = 0